/*
 * Global functions
 */
/* global global */

import { report } from '../../services/report';
import __ from '../../services/localization';

// Mock console.log if it doesn't exist (IE).
if (typeof console === 'undefined') {
  global.console = {
    log: function () {},
  };
}

/*
Disabled due to lack of support on backend
$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('Accepts-Version', window.apiVersion);
  },
});
*/

global.check_redirect = function (res) {
  if (res.redirect_to) {
    if (window.context_name === 'preview' && parent) {
      // Expired (completed) preview
      parent.postMessage(
        {
          type: 'STATUS_RESPONSE',
          status: 'expired',
        },
        '*'
      );
    } else if (parent && parent.length > 0 && /exit/.test(res.redirect_to)) {
      // Special handling of redirects to account.yougov.com from
      // Preview UI's iframe. Parent window (Preview UI) handles the redirect.
      parent.postMessage(
        {
          type: 'STATUS_RESPONSE',
          status: 'redirect',
          url: res.redirect_to,
        },
        '*'
      );
    }

    $(window).unbind('beforeunload');

    // Attempt to collect Shield device results before redirect
    try {
      return shield.shield.getDeviceResult().then(
        async (response) => {
          // resolve
          if (response) shieldRecorded = response.result.session_id;
          await reportData(window.ajax_error_max_tries);
          window.location.href = res.redirect_to;
          return true;
        },
        (response) => {
          // reject (passthru)
          if (window.newrelic) {
            const errorMessage = 'SHIELD getDeviceResult Promise Error';
            window.newrelic.noticeError(new Error(errorMessage), {
              errorMessage,
              response,
            });
          } else {
            console.error(`SHIELD getDeviceResult Promise Error: ${response}`);
          }
          window.location.href = res.redirect_to;
          return true;
        }
      );
    } catch (err) {
      if (window.newrelic) {
        const errorMessage = 'SHIELD getDeviceResult Error';
        window.newrelic.noticeError(new Error(errorMessage), {
          errorMessage,
          response: err,
        });
      } else {
        console.error(`SHIELD getDeviceResult Error: ${err}`);
      }
      window.location.href = res.redirect_to;
      return true;
    }
  }
  return false;
};

global.decodeHtmlEntities = function (string) {
  var txt = document.createElement('textarea');
  txt.innerHTML = string;
  return txt.value;
};

global.check_scroll = function (res) {
  if (res.scrollto) {
    window.setTimeout(function () {
      try {
        $.scrollTo('#' + res.scrollto, { offset: -100 });
      } catch (e) {}
    }, 200);
  } else {
    try {
      $.scrollTo(0);
    } catch (e) {}
  }
};

global.injectPartnerUrl = function (res) {
  if (res.partner_tracking_uri) {
    const partner_tracking_uri =
      process.env.BE_DOMAIN + res.partner_tracking_uri;
    if (Array.isArray(page_state._js)) {
      page_state._js.push(partner_tracking_uri);
    }
  }
};

global.check_timing = function (res) {
  if (res.record_timing) {
    page_state.starttime = Gryphon.util.get_page_time();
  }
};

global.contains_value = function (arr, val) {
  try {
    return arr.indexOf(val) != -1;
  } catch (e) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val) {
        return true;
      }
    }
    return false;
  }
};

/**
 * Connects page timers to events based on current page state or API response.
 *
 * @global
 * @function connect_page_timers
 * @param {Object} res - The API response object containing initialization state
 * @param {Object} [res.init_state] - Initial state data from the API
 * @param {Array<Array>} [res.init_state.timers] - Array of timer configuration tuples
 * @param {string} res.init_state.timers[][0] - The event name to bind the timer to
 * @param {Object} res.init_state.timers[][1] - Timer configuration object
 * @param {number} res.init_state.timers[][1].timeout - Timeout value in seconds
 * @param {string} res.init_state.timers[][1].callback - Name of the global callback function
 * @returns {void}
 *
 * @description
 * This function binds timer callbacks (click_skip / click_next) to specified events using the page_timer utility.
 */
global.connect_page_timers = function (res) {
  var timers = page_state.timers || res.init_state.timers;
  if (timers) {
    for (var i = 0; i < timers.length; i++) {
      var eventName, timer;
      eventName = timers[i][0];
      timer = timers[i][1];
      $(page_state).bind(
        eventName,
        page_timer(timer['timeout'], window[timer['callback']])
      );
    }
  }
};

/**
 * Connects widgets or template to the page based on current page state or API response.
 *
 * @global
 * @function connect_widgets_or_template
 * @param {Object} res - The API response object containing initialization state
 * @param {Object} [res.init_state] - Initial state data from the API
 * @param {Array<Object>} [res.init_state.widgets] - Array of widget configuration objects
 * @param {string} res.init_state.widgets[].question - The question parameter for the widget
 * @param {string} res.init_state.widgets[].view - The view parameter for the widget
 * @param {*} [res.init_state.template] - Template data to load if no widgets are available
 * @returns {void}
 *
 * @description
 * This function binds widget or template loading to the 'after_content_loaded_native' event.
 * It prioritizes widgets over templates when both are available.
 */
global.connect_widgets_or_template = function (res) {
  var widgets = page_state.widgets || res.init_state.widgets;
  var template = page_state.template || res.init_state.template;

  if (widgets) {
    for (var i = 0; i < widgets.length; i++) {
      // Load widget using provided widget data from API.
      $(page_state).bind(
        'after_content_loaded_native',
        Gryphon.load_widget(widgets[i].question, widgets[i].view)
      );
    }
  } else if (template) {
    // Load template using provided template data from API.
    $(page_state).bind(
      'after_content_loaded_native',
      Gryphon.load_template(template)
    );
  }
};

global.connect_nav_handlers = function (res) {
  if (!res.init_state) {
    return;
  }

  var buttons = [
    {
      button: mainNav.backButton,
      func: click_back,
    },
    {
      button: mainNav.nextButton,
      func: click_next,
    },
    {
      button: mainNav.skipButton,
      func: click_skip,
    },
  ];

  for (var i = 0; i < buttons.length; i++) {
    var btn = buttons[i];
    var handlers = res.init_state[btn.button.id + '_handlers'];
    if (handlers) {
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        btn.button.bind('click keypress', window[handler]);
      }
    } else {
      btn.button.bind('click keypress', btn.func);
    }
    btn.button.enable();
  }

  global.loaded_buttons();
};

global.create_custom_order = function (widget, qtype, order) {
  try {
    var $order = typeof order !== 'object' ? JSON.parse(order) : order;
    var c, element_row, element_id;
    if (qtype == 'multiple' || qtype == 'single') {
      element_row = '.dynamic-row';
      element_id = widget._object.element_id;
      // hide then unhide as necessary
      $(element_row)
        .find("div[id|='" + element_id + "'].question-response-item")
        .hide();
      for (c in $order) {
        if (
          $(element_row)
            .last()
            .find(
              "div[id|='" +
                element_id +
                '-' +
                $order[c] +
                "'].question-response-item"
            )
            .find('input').length == 0
        ) {
          $(
            "div[id|='" +
              element_id +
              '-' +
              $order[c] +
              "'].question-response-item"
          )
            .show()
            .find('input')
            .first()
            .closest(element_row)
            .insertAfter($(element_row).last());
        } else {
          // Does not need re-organizing within this loop
          $(
            "div[id|='" +
              element_id +
              '-' +
              $order[c] +
              "'].question-response-item"
          ).show();
        }
      }
    }
  } catch (e) {
    create_custom_order(widget, qtype, eval(order));
  }
};

global.debug_timing_push = function (event) {
  if (!collect_debug_page_timings) {
    return;
  }
  var perf_now = -1;
  if (window.performance && window.performance.now) {
    perf_now = window.performance.now();
  }
  debug_timings.push([event, page_state.this_page, Date.now(), perf_now]);
};

global.discover_variables = function (res) {
  page_state.allvars = res.variables;
};

global._fire_page_timer = function (cid, func, args) {
  if (page_state.page_events[cid] == 1) {
    func.apply(this, args);
  }
};

global.get_form_value = function (vname) {
  var v = document.forms[0][vname];
  if (Gryphon.util.isUndefinedOrNull(v)) {
    return '';
  }

  // some kind of finite, direct value..
  if (
    v.type == 'text' ||
    v.type == 'textarea' ||
    v.type == 'password' ||
    v.type == 'hidden' ||
    v.type == 'select-one' ||
    v.type == 'number'
  ) {
    if (v.value == undefined) {
      return '';
    }
    return v.value;
  }

  // radio list
  if (v.type == undefined && !Gryphon.util.isUndefinedOrNull(v.length)) {
    for (var x = 0; x < v.length; x++) {
      if (v[x].checked == true) {
        return v[x].value;
      }
    }
    return '';
  }

  // single radio item
  if (v.type == 'radio') {
    if ($(v).is(':checked')) {
      return v.value;
    }
    return '';
  }

  // checkbox
  if (v.type == 'checkbox') {
    if (v.checked) {
      if (Gryphon.util.isUndefinedOrNull(v.value)) {
        return '1';
      } else {
        return v.value;
      }
    } else {
      return '';
    }
  }

  // unknown type
  return '';
};

global.handle_keyboard_checkbox = function (selector) {
  $('body').on('keydown', selector, function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      var self = $(this);
      // Only listen for this 'changed' event when 'keydown' event occurs
      self.one('changed', function () {
        self.focus();
      });
    }
  });
};

global.on_change = function (e) {
  // Click the element, and update it's
  // aria-checked attribute for screen readers
  keyboard_select(e);
  if (e.keyCode == 13 || e.keyCode == 32) {
    switch (e.target.getAttribute('aria-checked')) {
      case 'true':
        e.target.setAttribute('aria-checked', 'false');
        break;
      case 'false':
        e.target.setAttribute('aria-checked', 'true');
        break;
      default:
        break;
    }
  }
};

global.page_timer = function (seconds, func) {
  var args = new Array();
  for (var i = 2; i < arguments.length; i++) {
    args.push(arguments[i]);
  }
  var cid = Gryphon.util.gen_rand_string(30);
  page_state.page_events[cid] = 1;
  window.setTimeout(function () {
    _fire_page_timer(cid, func, args);
  }, seconds * 1000);
};

// Used in survey customization
global.ready = function (callback) {
  $(page_state).on('after_content_loaded', callback);
};

global.keyboard_select = function (e) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    e.target.click();
  }
};

global.scale_select_tab = function (e, name, name_dk, value) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    scale_select(name, name_dk, value);
  }
};

global.scale_select = function (name, name_dk, value) {
  var el, elms;
  el = $('#r-' + name + '-' + value);
  elms = $('.' + name + ' .scale-options .scale_button');
  if (el != null && el.attr('class')) {
    el.removeClass();
    elms.attr('class', 'scale_button scale_cell_value');
    el.addClass('scale_button_high');
    el.addClass('scale_cell_value');
    $('.' + name)
      .find('.scale_button')
      .attr('aria-checked', false);
    el.attr('aria-checked', true);
    el.attr('data-value', value);
  }
  var v = $('input[name=' + name + ']');
  v.val(value);

  // [GRYP-12559] Only attempt to disable a DK checkbox if provided a name.
  if (name_dk) global.disable_dk_check(name_dk);

  // Special handling for 'hidden-response' elements
  // only remove the class (unhide the selected value)
  // for the current scale (not all scales on the page)
  $('tr.' + name)
    .find('div.scale_cell_value')
    .filter('.scale_button_high')
    .removeClass('hidden-response')
    .end();

  // remove any focus states
  elms.find('*').blur();
};

global.disable_dk_check = function (name_dk) {
  // If we've provided a 'name' for the DK input, we should
  // use it to target the specific DK input on the page
  // as there could be multiple instances
  var $name = '';
  if (name_dk) {
    $name = '[name="' + name_dk + '"]';
  }
  if ($('.dk-check:visible' + $name).prop('checked')) {
    $('.dk-check:visible' + $name).prop('checked', false);
    $('.dk-check:visible' + $name)
      .closest('.dk-input')
      .find('.uniform-checked')
      .removeClass('uniform-checked');
    if (!name_dk) {
      // Note: this could cause undesirable effects if there
      // are multiple questions on one page with hidden responses
      // because of previously selected DK values
      $('.hidden-response:visible').removeClass('hidden-response');
    }
    $('.hidden-check').removeClass('hidden-check');
  }
};

global.set_language_direction = function (rtl) {
  var html = $('html');

  if (rtl) {
    html.attr('dir', 'rtl');
  } else {
    html.attr('dir', 'ltr');
  }
};

global.set_page_name_visibility = function (res) {
  if (res.show_page_name) {
    $('#div_page_name_api')
      .text(
        'Page: ' +
          (res.init_state && res.init_state.this_page
            ? res.init_state.this_page
            : 'Undefined')
      )
      .show();
  } else {
    $('#div_page_name_api').hide();
  }
};

global.set_fraud_tracking = function (res) {
  if (res?.fraud) {
    var { rd_signed_url } = res.fraud;
    try {
      $.ajax({
        type: 'GET',
        url: `${rd_signed_url}`,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 5,
        global: false,
        success: function (response) {
          page_state.vardata['__fraud_response__'] = JSON.stringify(response);
        },
        error: function (xhr, status, error) {
          page_state.vardata[
            '__fraud_response__'
          ] = `Error assessing fraud with Research Defender: ${JSON.stringify(
            xhr
          )}`;

          if (!window.newrelic || !xhr || !error) return;

          const errorMessage = `Error assessing fraud with Research Defender: ${error} (status code: ${xhr.status})`;
          window.newrelic.noticeError(new Error(errorMessage), {
            errorMessage,
            response: xhr.statusText,
            status: xhr.status,
            requestURL: `${rd_signed_url}`,
            method: 'GET',
            ajaxErrorListener: false,
          });
        },
      });
    } catch (e) {
      page_state.vardata[
        '__fraud_response__'
      ] = `Error assessing fraud with Research Defender: ${e}`;
    }
  }
};

global.set_footer_text = function (res) {
  if (res.footer !== undefined) {
    $('.footer-text').html(res.footer).show();
  }
};

global.set_nav_button_visibility = function (res) {
  var back = mainNav.backButton;
  var next = mainNav.nextButton;

  // FIXME: There is some legacy JS that will send an Object with
  // 'next_button' and 'back_button' as keys, hence the reason why we need to
  // bend ourselves backwards to check for that possibillity here (see
  // `dyngrid.js`)

  // Configure back button.
  if (res[back.id] === undefined) {
    back.hide();
  } else if (res[back.id]) {
    back.show();
  } else if (Object.prototype.hasOwnProperty.call(res, 'back_button')) {
    if (res['back_button']) {
      back.show();
    } else {
      back.hide();
    }
    if (res.no_back_nav === true) {
      back.prop('no-back-nav');
    }
  } else {
    back.hide();
  }

  // Configure next button.
  if (res[next.id] === undefined) {
    next.hide();
  } else if (res[next.id]) {
    next.show();
  } else if (Object.prototype.hasOwnProperty.call(res, 'next_button')) {
    if (res['next_button']) {
      next.show();
    } else {
      next.hide();
    }
  } else {
    next.hide();
  }

  if (res.hide_nav === true) {
    mainNav.hide();
  } else {
    mainNav.show();
  }
};

global.set_query_params = function (data) {
  const qs = new URLSearchParams(window.location.search.replace('?', ''));
  const allowedKeys = ['session_settings_id'];
  const filtered = new URLSearchParams();

  for (const key of allowedKeys) {
    // For now, we only care about appending
    // query string to non-submitting POSTs
    if (qs.has(key) && '__submit__' in data === false) {
      filtered.append(key, qs.get(key));
    }
  }

  return filtered.toString() ? `?${filtered.toString()}` : '';
};

global.set_spd_elements_state = function (res) {
  /**
   * Display SPD (GDPR) consent content
   */
  if (res.is_spd_question) {
    if (res.show_consent_text) {
      $('.spd-consent-text p').text(res.consent_text);
      $('.spd-content').show();
      page_state['spd_consent_text_shown'] = true;
    }
    $('a.spd-consent-skip').text(res.skip_text);
    mainNav.skipButton.show();
  }
};

global.uncheck_array = function (element_ids) {
  for (var i = 0; i < element_ids.length; i++) {
    var el = $('#' + element_ids[i]);
    if (el && el.is(':checked')) {
      el.prop('checked', false);
      $.uniform.update('#' + element_ids[i]);
    }
  }
};

global.update_pbar = function (res) {
  if (res.progress) {
    $('#prog_bar').show();
    var progress = (res.progress / 100) * 100;
    $('#pbar_in').css('display', 'block');
    $('#pbar_in').css('width', (res.progress / 100) * 100 + '%');
    //$("#pb_amt").text(res.progress + '');
    $('#prog_bar .bar').css('width', progress + '%');
  } else {
    $('#pbar_cont').addClass('disabled');
  }
};

global.removeFocusBorderSelect = function () {
  var opened = false;
  var selectElm = $('select');
  selectElm.on('click change blur', function (evt) {
    switch (evt.type) {
      case 'blur':
        opened = false;
        $(this).removeClass('nofocus');
        break;
      case 'click':
        opened = $(this).hasClass('nofocus') ? true : !opened;
        if (opened) {
          if (!$(this).hasClass('nofocus')) {
            $(this).addClass('nofocus');
          }
        } else {
          $(this).removeClass('nofocus');
        }
        break;
      case 'change':
        opened = false;
        $(this).removeClass('nofocus').blur();
        break;
    }
  });
};

global.injectDeviceBrowser = function () {
  document.documentElement.classList.add(device(), OS(), browser());

  function device() {
    let deviceType = 'Unknown';
    if (
      agentHas('Tablet') ||
      agentHas('Tablet PC') ||
      agentHas('iPad') ||
      agentHas('Kindle') ||
      agentHas('Nexus') ||
      (agentHas('Android') && !agentHas('Mobi'))
    ) {
      deviceType = 'Tablet';
    } else if (
      agentHas('Mobi') ||
      agentHas('iPhone') ||
      agentHas('iPod') ||
      agentHas('Android')
    ) {
      deviceType = 'Mobile';
    } else {
      deviceType = 'Desktop';
    }

    return deviceType.toLowerCase();
  }

  function OS() {
    let OSName = 'Unknown-OS';
    if (agentHas('Win')) {
      OSName = 'Windows';
    } else if (agentHas('Macintosh')) {
      OSName = 'MacOs';
    } else if (agentHas('Linux') && !agentHas('Android')) {
      OSName = 'Linux';
    } else if (agentHas('Android') && !agentHas('like Android')) {
      OSName = 'Android';
    } else if (agentHas('like Mac')) {
      OSName = 'iOS';
    }

    return OSName.toLowerCase();
  }

  function browser() {
    let browserName = navigator.appName;

    if (
      agentHas('CriOS') ||
      agentHas('CrOS') ||
      agentHas('Crmo') ||
      agentHas('Chromium') ||
      agentHas('Chrome') ||
      !!window.chrome
    ) {
      browserName = 'Chrome';
    } else if (
      (!!window.ApplePaySetupFeature || !!window.safari) &&
      (agentHas('Safari') || agentHas('Applewebkit')) &&
      !agentHas('Chrome') &&
      !agentHas('CriOS')
    ) {
      browserName = 'Safari';
    } else if (
      agentHas('Firefox') ||
      agentHas('FxiOS') ||
      agentHas('Iceweasel') ||
      agentHas('Focus')
    ) {
      browserName = 'Firefox';
    } else if (agentHas('Opera') || agentHas('Opr') || agentHas('OpiOS')) {
      browserName = 'Opera';
    } else if (agentHas('Msie') || agentHas('Trident')) {
      browserName = 'IE';
    } else if (
      agentHas('Edge') ||
      agentHas('EdgiOS') ||
      agentHas('Edga') ||
      agentHas('Edg')
    ) {
      browserName = 'Edge';
    }

    return browserName.toLowerCase();
  }

  function agentHas(keyword) {
    return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
  }
};

injectDeviceBrowser();

// Removal of red lines under spelling errors cannot be consistently enforced for editable elements (or form fields),
// on all browsers/platforms, when those elements are blurred - regardless of the spellcheck attributes value being set to "false".
// In case we update the innerHTML of the element, the spellcheck will be re-evaluated
// Reasigning the value fixes this with the below solution
global.disableSpellCheck = function (id) {
  const inputFieldId = $(id);
  const valueinputFieldId = inputFieldId.val();
  inputFieldId.val('');
  inputFieldId.val(valueinputFieldId);
};

global.display_feedback_widget = function (res) {
  if (res?.display_feedback_widget && !isNaN(window.hotjarId)) {
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: window.hotjarId, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
};

global.set_input_error_text = function () {
  const errorMsgKey = 'Error';
  const errorMsgTranslated = __.localize(errorMsgKey);
  $('#error_input_id').html(errorMsgTranslated);
};

global.configCatFeatureFlags = (function () {
  var featureFlags;

  function setFeatureFlags(value) {
    featureFlags = value;
  }

  function getFeatureFlag(key) {
    return featureFlags[key];
  }

  function getAllFeatureFlags() {
    return featureFlags;
  }

  return {
    set: setFeatureFlags,
    get: getFeatureFlag,
    getAll: getAllFeatureFlags,
  };
})();

global.shieldMonitoring = function () {
  const enabled = global.configCatFeatureFlags.get('fe_shield') || false;
  if (
    typeof window.shield !== 'undefined' &&
    window.context_name !== 'preview' &&
    enabled &&
    !shieldRecorded &&
    !isDeviceDataInProgress
  ) {
    try {
      deviceData();
    } catch (e) {
      if (typeof e == 'string' && e.includes('module not initialised')) {
        try {
          shield.init(shieldProps).then(function () {
            deviceData();
          });
        } catch (err) {
          if (window.newrelic) {
            const errorMessage = 'SHIELD init Error';
            window.newrelic.noticeError(new Error(errorMessage), {
              errorMessage: errorMessage,
              response: err,
            });
          }
        }
      }
    }
  }
};

const pageLoadAndDelayPromise = new Promise((resolve) => {
  const onPageLoad = () => setTimeout(resolve, 15000);
  if (document.readyState === 'complete') {
    onPageLoad();
  } else {
    window.addEventListener('load', onPageLoad);
  }
});

async function deviceData() {
  isDeviceDataInProgress = true;
  await pageLoadAndDelayPromise;
  try {
    const response = await shield.getDeviceIntelligence();
    shieldRecorded = response.result.session_id;
    reportData(window.ajax_error_max_tries);
  } catch (err) {
    if (window.newrelic) {
      const errorMessage = 'SHIELD deviceIntelligence Error';
      window.newrelic.noticeError(new Error(errorMessage), {
        errorMessage,
        response: err,
      });
    }
    setTimeout(deviceData, ++backoffFactor * 10000);
  }
}

function reportData(retriesLeft) {
  return new Promise((resolve, reject) => {
    try {
      if (window.segments && shieldRecorded) {
        const url = `${process.env.API_BASE_URL}shield/${window.segments}/${shieldRecorded}`;

        var config = {
          url,
          method: 'PUT',
          xhrFields: {
            withCredentials: true,
          },
          global: false,
          timeout: window.ajax_timeout,
          success: function () {
            resolve();
          },
          error: function (xhr, textStatus) {
            if (
              (textStatus == 'timeout' || _.inRange(xhr.status, 500, 699)) &&
              retriesLeft > 0
            ) {
              retriesLeft--;
              setTimeout(function () {
                reportData(retriesLeft).then(resolve, reject);
              }, 5000);
            } else {
              if (!window.newrelic || !xhr) {
                resolve(); // Resolve even on error to allow any redirects to proceed
                return;
              }

              const errorMessage = `SHIELD Error reporting data: ${xhr.statusText} (status code: ${xhr.status})`;
              window.newrelic.noticeError(new Error(errorMessage), {
                errorMessage,
                response: xhr.statusText,
                status: xhr.status,
                requestURL: url,
                method: 'PUT',
                ajaxErrorListener: false,
              });
              resolve(); // Resolve even on error to allow any redirects to proceed
            }
          },
        };

        $.ajax(config);
      } else {
        throw new Error('Missing segments or sessionId');
      }
    } catch (err) {
      if (window.newrelic) {
        const errorMessage = 'SHIELD session_id to Gryphon Error';
        window.newrelic.noticeError(new Error(errorMessage), {
          errorMessage,
          response: err,
        });
      }
      if (err.statusText == 'timeout') {
        setTimeout(function () {
          reportData(retriesLeft).then(resolve, reject);
        }, 5000);
      } else {
        resolve(); // Resolve even on error to allow any redirects to proceed
      }
    }
  });
}
